export const organisationalUnitTypes = {
  HOME: 'HOME',
  GROUP: 'GROUP',
};
